import { ProjectData } from 'src/app/entities/project-data.entity';
import { Utils } from '../../utils.module';
import { DB } from '../../datas/db';
import { ProjectDataPresupuesto } from 'src/app/entities/project-data-presupuesto-entity';
import { UtilsBuilder } from '../utils-builder';
import { Poste3d } from '../scheme3d/poste3d';
import { Puerta3d } from '../scheme3d/puerta3d';
import { Varios3d } from '../scheme3d/varios3d';
import { Panels3d } from '../scheme3d/panels3d';
import { Datas3d } from '../scheme3d/datas3d';
import * as THREE from 'three';
import { CoorMaps } from '../scheme3d/coor-maps';
import { SubSectionSatelite } from './sub-section-satelite';
import { ProjectDataPuerta } from '../../entities/project-data-puerta.entity';
import { resolveTripleslashReference } from 'typescript';

export class DatasSatelite {
	// Si es true, se hace la petición de carga de archivos 3D (POR DEFECTO).
	// Si es false, no se hace la petición de carga de archivos 3D solo se obtiene la infromación, usado por el presupuesto.
	private WITH_3D = true;

	private _proyecto: ProjectData;

	public postes: Poste3d;
	public puertas: Puerta3d;
	public varios: Varios3d;
	public bastidores: Panels3d;
	public datas: Datas3d[];
	public ColorNeutro: THREE.MeshPhongMaterial;

	private _procesando = 0; // No está procesando.
	public vectorDirectorAB: { x: number;  z: number; };
	public posicionPosteDoble: { x: number; y: number, z: number; };
	public get processando() { return this._procesando; }
	private _procesandoLimite = 0; // Tiempo limite para procesar.
	private _cantidadPeticiones = 0; // Cantidad de peticiones en espera.

	private utilsBuilder: UtilsBuilder;

	public get ProccessEnd(): boolean {
		return (this._cantidadPeticiones === 0 && this._procesando === 0);
	}

	private _status = 0; // Como finaliza el proceso => 0 = OK, 1 = límite de tiempo superado.
	public get status() { return this._status; }

	constructor(debug = false) {
		this.utilsBuilder = new UtilsBuilder();

		this.postes = new Poste3d('assets/3D/', debug);
		this.puertas = new Puerta3d('assets/3D/', debug);
		this.varios = new Varios3d('assets/3D/', debug);
		this.bastidores = new Panels3d('assets/3D/', debug);

		// Material usado para colorear.
		this.ColorNeutro = new THREE.MeshPhongMaterial({ color: 0xffffff, specular: 0, emissive: 0, shininess: 0 });
	}

	// Crea las divisiones sin cargar los modelos 3D.
	public insertNo3D(proyecto: ProjectData, obj3d = false) {
		this.WITH_3D = obj3d;

		// Linkar proyecto.
		this._proyecto = proyecto;
		this.datas = [];
		if (this._procesando === 0) this.elevationsSatelite();
	}

	//
	public get loadFinish() {
		return !(this.postes.cargando || this.puertas.cargando || this.varios.cargando || this.bastidores.cargando);
	}


	// ########################## Procesar las elevaciones para crear el presupuesto.
	private elevationsSatelite() {
		this._status = 0;
		this._procesandoLimite = 0;
		this._procesando = 1;

		//   Se almacenan las coordenadas lat, lng para perdir sus elevaciones.
		// Contiene todas las coordenadas LatLng de todos los perímetros del proyecto,
		// ordenados desde el perímetro 0 al n, teniendo en cuenta que sus puntos base también
		// ejecutan el mismo orden ascendente.
		//
		//   De esta forma con una llamada obtenemos todas las elevaciones de los poste base, después
		// se debe leer de forma ordenada las elevaciones devueltas por googleMaps.
		// | Per.0  | Per.1 | Per.n ...
		// |01234567|0123456|012345... (puntos base de los perímetros.)
		let coorsElevation = [];

		// Ciclo por perímetros.
		for (let [indexPerimeter, perimetro] of this._proyecto.perimetro.entries()) {
			// Preparar si no tienen projectData.perimetro[...].presupuesto.unity
			if (!perimetro.presupuesto) perimetro.presupuesto = new ProjectDataPresupuesto();

			// Longitud total con elevaciones por perímetro.
			perimetro.longitudML = 0;
			perimetro.presupuesto.unity.ml = 0;
			// Longitud esférica
			perimetro.longitud = 0;

			// Puntos base del perímetro, actualizar formato. En caso de proyectos antiguos.
			for (let coor of perimetro.coordenadas) {
				if (!coor.dots) { //let v = UtilsBuilder.latLngToVector3d(coor.lat, coor.lng);
					coor.dots = [{ lat: coor.lat, lng: coor.lng, ele: 0, x: 0, y: 0, z: 0 }];
				}
			}

			// Crear un bloque de datos nuevo para el perímetro.
			// Agrupa toda la información necesaría para controlar el perímetro en presupuesto como 3D.
			let datas3d = new Datas3d(); // Contiene los tramos e información del perímetro.

			// Relaciones el banco de datos con su perímetros.
			this.datas[indexPerimeter] = datas3d;

			// Si WITH_3D = true llama a los cargadores de objetos 3D.
			datas3d.setDatas(perimetro, this.bastidores, this.postes, this.varios, this.WITH_3D);

			// Obtener longitudes esféricas entre puntos base.
			perimetro.tramos = [0];
			for (let indexCoor = 0; indexCoor < perimetro.coordenadas.length; indexCoor++) {
				// Obtener las coordenadas del perímetro.
				let coor = perimetro.coordenadas[indexCoor];

				// Almacenar LatLng para la llamadas a las elevaciones GooglMaps.
				coorsElevation.push(new google.maps.LatLng(coor.dots[0].lat, coor.dots[0].lng));

				// Pasar de LatLng a Vector3.
				let v3 = UtilsBuilder.latLngToVector3d(coor.dots[0].lat, coor.dots[0].lng);
				coor.dots[0].x = v3.x; coor.dots[0].y = v3.y; coor.dots[0].z = v3.z;

				// Calcula la longitud total del perímetro obteniendo la adaptación de las coordenadas a google.maps.
				if (indexCoor > 0) {
					let coorB = perimetro.coordenadas[indexCoor - 1].dots[0];
					let magnitud = google.maps.geometry.spherical.computeDistanceBetween(
						new google.maps.LatLng(coorB.lat, coorB.lng),
						new google.maps.LatLng(coor.dots[0].lat, coor.dots[0].lng));

					// Se utiliza?????
					//perimetro.coordenadas[indexCoor].e sfe = magnitud;

					// Longitud esférica del tramo.
					perimetro.tramos.push(magnitud);

					// Sumar todas las longitudes para obtener la longotid total del perímetro.
					perimetro.longitud += magnitud;
				}
			}
		}

		// Llamada a las elevaciones de los postes base.
		// Los puntos base están en orden de prímetro y punto base.
		let elevator = new google.maps.ElevationService();
		elevator.getElevationForLocations({ 'locations': coorsElevation },
			(results, status) => {
				switch (status) {
					case google.maps.ElevationStatus.OK:

						// Indice el punto dentro del listado de elevaciones.
						let indexDatos = 0;

						// Se recorren todos los perímetros para extraer sus puntos base en serie.
						for (let [indexPerimeter, perimeter] of this._proyecto.perimetro.entries()) {
							// Última coordenada del perímetro actual.
							let last = perimeter.coordenadas.length - 1;

							// Perímetros cerrado o abierto.
							//let closed = false;
							// Comprobar si está cerrado.
							//if (perimeter.coordenadas.length > 2) { // Solo se puede cerrar un perímetro si tiene más de dos puntos base.
							//	closed = (perimeter.coordenadas[0].dots[0].lat === perimeter.coordenadas[last].dots[0].lat
							//		&& perimeter.coordenadas[0].dots[0].lng === perimeter.coordenadas[last].dots[0].lng);
							//}

							// Almacenar las elevaciones.
							for (let c of perimeter.coordenadas) {
								c.dots[0].ele = results[indexDatos].elevation;
								indexDatos++;
							}

							// obtener la referencia al banco de datos del perímetro.
							let datas3d = this.datas[indexPerimeter];

							// Ya tenemos todas las elevaciones de los punto base.
							// Ahora hay que dividir los tramos y obtener todos los postes necesarios.
							this._proccessCoordinatesSatelite(indexPerimeter, datas3d);		// Dividir en secciones.
						}

						// Ahora con las elevaciones y secciones calcular los postes.
						this.obtenerPostes(); //indexPerimeter);
						break;

					case google.maps.ElevationStatus.INVALID_REQUEST:
						console.error('GetorDatas3D:: Elevaciones google maps INALID REQUEST');
						break;
					case google.maps.ElevationStatus.OVER_QUERY_LIMIT:
						console.error('GetorDatas3D:: Elevaciones google maps OVER QUERY LIMIT');
						break;
					case google.maps.ElevationStatus.REQUEST_DENIED:
						console.error('GetorDatas3D:: Elevaciones google maps DENIED');
						break;
					case google.maps.ElevationStatus.UNKNOWN_ERROR:
						console.error('GetorDatas3D:: Elevaciones google maps UNKNOWN ERROR');
						break;
				}
			});
	}

	// Array [d,lat,lng,e,...] de números que contienen los postes. Se debe leer de cuatro en cuatro.
	// la primera contiene el tipo de poste, 'd' es una dato con valores binarios (flags).
	// 0000 0000 [  0] => El poste por defecto, ej.: 1m00.
	// 1000 0000 [128] => Poste siguientes, ej.: 1m50, cuando hay diferencia de alturas.
	// 0000 0001 [  1] => Poste recto con tornapuntas.
	// 1000 0001 [129] => Poste recto con tornapuntas, siguiente poste.
	// 0000 0010 [  2] => Poste extremo Izquierdo.
	// 1000 0010 [130]=> Poste extremo Izquierdo, siguiente poste.
	// 0000 0100 [  4] => Poste extremo Derecho.
	// 1000 0100 [132]=> Poste extremo Derecho, siguiente poste.
	// 0000 1000 [  8] => Poste angulo (tornapuntas) externo, tiene la malla por el angulo grande.
	// 1000 1000 [136] => Poste angulo (tornapuntas) externo, tiene la malla por el angulo grande, poste siguiente.
	// 0001 0000 [ 16] => Poste angulo (tornapuntas) interno, tiene la malla por el angulo agudo.
	// 1001 0000 [144] => Poste angulo (tornapuntas) interno, tiene la malla por el angulo agudo, poste siguiente.
	// 'lat' y 'lng' contienen la latitud y longitud respectivamente.
	// 'e' es la elevación proporcionada por googleMaps.
	// Rellena en el proyecto el array post [d,lat,lng,e,...] y el parametro revisarAlturas, por perímetro.
	// ESPECIALES::
	//	1000 0000 [128] => Añadir para indicar que es con desnivel (_des) poste con la altura soguiente.
	//	0100 0000 [ 64] => Añadir para indicar que el angulo no debe tener torna puntas (40º a 140º si tiene tornapuntas).

	// Hace llamadas a google.maps para conseguir la elevaciones de los postes intermedios de todos los perímetros.
	private obtenerPostes() { //indexPerimeter: number) {

		let esCercado = false;
		let db = new DB();

		let lastSectionCache: SubSectionSatelite = undefined;
		// >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> LEER LOS PERÍMETROS.
		for (let [indexPerimeter, perimeter] of this._proyecto.perimetro.entries()) {
			// Aquí se almacenan todos LatLng para la petición a GoogleMaps de sus elevaciones.
			let peticiones = [];
			perimeter.post = []; // Se almacena información: tipoPoste, lat, lng, elevación,...

			esCercado = (perimeter.producto.familia.tipo === DB.CERCADO);
			// Obtener información del panel.
			let panelInfo = (esCercado) ?
				db.cercados.find(v => { return v.idUnity === perimeter.producto.modelo.idUnity; }) :
				db.verjas.find(v => { return v.idUnity === perimeter.producto.modelo.idUnity; });

			let datas3d = this.datas[indexPerimeter]; // Obtener referencia al banco de datos del perímetro.
			for (let indexCoor = 0; indexCoor < datas3d.coors.length - 1; indexCoor++) {

				// Referencia a la actual coordenada.
				let coor = datas3d.coors[indexCoor];
				//console.log(`GRADOS::${coor.grados} DIR::${coor.dir} INTERM::${coor.interm}`);

				// LatLng de los puntos del tramo A -> B.
				let dotA = new google.maps.LatLng(perimeter.coordenadas[indexCoor].dots[0].lat, perimeter.coordenadas[indexCoor].dots[0].lng);
				//	let dotB = new google.maps.LatLng(perimeter.coordenadas[indexCoor + 1].dots[0].lat, perimeter.coordenadas[indexCoor + 1].dots[0].lng);

				// Vector3 de los puntos del tramo A -> B.
				let vdotA = UtilsBuilder.latLngToVector3d(perimeter.coordenadas[indexCoor].dots[0].lat, perimeter.coordenadas[indexCoor].dots[0].lng);
				let vdotB = UtilsBuilder.latLngToVector3d(perimeter.coordenadas[indexCoor + 1].dots[0].lat, perimeter.coordenadas[indexCoor + 1].dots[0].lng);
				const p1:THREE.Vector3 = vdotA.clone();
				const p2:THREE.Vector3 = vdotB.clone();

				p1.y = 0;
				p2.y = 0;

				let length = p1.distanceTo(p2);
				// >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> LEER LAS SECCIONES.
				// Recorrer las secciones de los tramos.
				for (let [indexSeccion, section] of coor.sections.entries()) {

					// El poste incial siempre se pone en normal.
					let _poste = 0;
					// ############################## DEFINIR EL TIPO DE POSTE INICIAL DE CADA SECCIÓN ###########################################
					// ############################## Es la primera sección.
					if (indexSeccion === 0) { // Se trata aparte ya que puede ser un estremo IZQ:DER o un angulo ANG:INT.
						console.log("---To have a look---");
						// console.log("·····················0············");
						// console.log("perimeter.post", perimeter.post);
						// Es un extemo en un perímetro abierto y la sección es una puerta.
						if (section.door !== '') { // Si es una puerta, siempre será un estremo IZQ:DER según dirección y no rellena.
							/*if (datas3d.closed) {
								_poste = this._direccionExtremo(datas3d); // (datas3d.dire ction === 1) ? 2 : 4; // IZQ : DER.
								perimeter.post = perimeter.post.concat(_poste, 0, 0, 0);
								peticiones.push(dotA);
							}*/
							lastSectionCache = section;
							continue; // Pasar al siguiente, la puerta no tiene postes de relleno.
						}

						if (indexCoor === 0) { // Si es la primera coordenada indica que es el primer poste del perímetro
							// (solo se cumple una vez por perímetro).
							if (!datas3d.closed) { // Está abierto colocar estremo dependiendo de la dirección de dibujo IZQ/DER.
								// FIXME tener en cuenta si hay puerta al final o principio.
								_poste = this._direccionExtremo(datas3d); // ( datas3d.dire ction === 1) ? 2 : 4; // IZQ : DER.
							}
							else { // Está cerrado se coloca un angulo según su orientación.
								// Tener en cuenta si la última sección del perímetro es una puerta, se debe colocar un estremo.
								let lastCoor = datas3d.coors[perimeter.coordenadas.length - 2];
								let lastSection = lastCoor.sections[lastCoor.sections.length - 1];
								if (lastSection.door !== '') { // Es una puerta, poner un estremo.
									_poste = this._direccionExtremo(datas3d); // (datas3d.dire ction === 1) ? 2 : 4; // IZQ : DER.
								}
								else {
									_poste = this._direccionAngulo(lastSectionCache, coor, datas3d);
									//if (lastSectionCache.door === '') _poste = this._direccionAngulo(coor.interm); // ? 8 : 16; // ANG : INT.
									//else _poste = this._direccionExtremo(datas3d);
									//if (coor.grados) { if (coor.grados < 40 || coor.grados > 140) _poste |= 64; // Angulo sin tornapuntas.
									//}
								}
							}
						}
						// Todos los tramos restantes (coordenadas).
						else {
							if (section.door !== '') { // Si es una puerta, siempre sera un estremo IZQ:DER según dirección y no rellena.
								if (indexSeccion > 0) {
									_poste = this._direccionExtremo(datas3d); // (datas3d.dire ction === 1) ? 2 : 4; // IZQ : DER.
									perimeter.post = perimeter.post.concat(_poste, 0, 0, 0);
									peticiones.push(dotA);
								}
								lastSectionCache = section;
								continue; // Pasar al siguiente, la puerta no tiene postes de relleno.
							}
							else { // Colocar un angulo.
								_poste = this._direccionAngulo(lastSectionCache, coor, datas3d);
								//if (lastSectionCache.door === '') _poste = this._direccionAngulo(coor.interm); // ? 8 : 16; // ANG : INT.
								//else _poste = this._direccionExtremo(datas3d);
								//if (coor.grados) { if (coor.grados < 40 || coor.grados > 140) _poste |= 64; // Angulo sin tornapuntas.
								//}
							}
						}
						// console.log("··················02···············");
						// console.log("perimeter.post", perimeter.post);
					}
					// ---------------------------------------------------------- Resto de secciones.
					else {
						if (section.door !== '') { // Si es una puerta colocar un estremo y no rellenar con postes.
							// console.log("·································");
							// console.log("perimeter.post", perimeter.post);
							_poste = this._direccionExtremoInverso(datas3d); // (datas3d.dire ction === 1) ? 2 : 4; // IZQ : DER.
							perimeter.post = perimeter.post.concat(_poste, 0, 0, 0);
							peticiones.push(dotA);
							lastSectionCache = section;
							continue; // Pasar al siguiente, la puerta no tiene postes de relleno.
						}
						// El resto de las secciones empiezan por un estremo invertido.
						_poste = this._direccionExtremo(datas3d); // (datas3d.dire ction === -1) ? 2 : 4; // IZQ : DER.
					}

					// Almacenar poste y petición de elevación.
					perimeter.post = perimeter.post.concat(_poste, 0, 0, 0);
					// console.log("···············03··················");
					// console.log("perimeter.post", perimeter.post); // [4, 0, 0, 0]

					peticiones.push(dotA);

					// ########################################## RELLENAR LA SECCIÓN CON POSTES.
					// Si la sección es igual o menor al tamaño del bastidor no rellenar con postes.
					// console.log(length);
					//console.log(datas3d.coors. )
					// console.log("--" + panelInfo.longitud);
					// console.log(this.datas[0].separation)
					if (section.magnitud > panelInfo.longitud) {
						// Cantidad de bastidores.
						let div = Math.floor(section.magnitud / this.datas[0].separation/*panelInfo.longitud*/);
						// console.log("div: " + div);
						//console.log(section.magnitud / panelInfo.longitud);
						// Obtener el resto.
						let margenEnd = section.magnitud % /*panelInfo.longitud*/this.datas[0].separation;
						//console.log("margenEnd: " + margenEnd);
						// Margen desde el punto inicial del cual se empieza a colocar postes.
						let margenStart = /*panelInfo.longitud*/this.datas[0].separation;
						//console.log("margenStart: " + margenStart);

						// Si el sobrante es menor al 30% repartir.
						if ((margenEnd / (this.datas[0].separation / 100)) < 30) {
							// console.log("ENTRA EN LO SOBRANTE");
							margenStart = (margenStart + margenEnd) / 2;
							margenEnd = margenStart;
						}

						// Copia del punto A que sa va a desplazar por la línea.
						let ret = 0; // Cada 10 pone un poste Rect para los Cercados.
						for (let pet = 0; pet < div; pet++) {
							let _v = this.utilsBuilder.tramoAtoB(vdotA, vdotB, margenStart);
							let move = new google.maps.LatLng(UtilsBuilder.vector3dToLatLng(_v));
							peticiones.push(move); // Petición.
							ret++;
							if (ret == 10 && perimeter.producto.familia.tipo === DB.CERCADO) {
								ret = 0;
								perimeter.post = perimeter.post.concat(1, 0, 0, 0); // Poste intermedio con tornapuntas.
							}
							else { perimeter.post = perimeter.post.concat(0, 0, 0, 0); }
							margenStart += panelInfo.longitud;
						}
					}

					lastSectionCache = section;
				}
			}
			// console.log("···············04··················");
			// console.log("perimeter.post", perimeter.post);
			// Si no esta cerrada incluir el último poste.
			if (!datas3d.closed) {
				// Si la última sección del útimo tramo es una puerta no colocar poste.
				if (lastSectionCache && lastSectionCache.door === '') {
					let last = perimeter.coordenadas[perimeter.coordenadas.length - 1];
					let pst = this._direccionExtremoInverso(datas3d); //  4 : 2; // IZQ : DER inversa.
					perimeter.post = perimeter.post.concat(pst, 0, 0, 0);
					peticiones.push(new google.maps.LatLng(last.dots[0].lat, last.dots[0].lng)); // Petición.
				}
			}
			// else {
			// 	if (lastSectionCache && lastSectionCache.door === '') {
			// 		let last = perimeter.coordenadas[perimeter.coordenadas.length - 1];
			// 		let pst = this._direccionExtremoInverso(datas3d); //  4 : 2; // IZQ : DER inversa.
			// 		perimeter.post = perimeter.post.concat(pst, 0, 0, 0);
			// 		peticiones.push(new google.maps.LatLng(last.dots[0].lat, last.dots[0].lng)); // Petición.
			// 	}
			// }
			// console.log(datas3d);
			/*if (datas3d.coors.length == 2) {
				// Si la última sección del útimo tramo es una puerta no colocar poste.
				if (lastSectionCache && lastSectionCache.door === '') {
					let last = perimeter.coordenadas[perimeter.coordenadas.length - 1];
					let pst = this._direccionExtremoInverso(datas3d); //  4 : 2; // IZQ : DER inversa.
					perimeter.post = perimeter.post.concat(pst, 0, 0, 0);
					peticiones.push(new google.maps.LatLng(last.dots[0].lat, last.dots[0].lng)); // Petición.
				}
			}*/
			// console.log("···············05··················");
			// console.log("perimeter.post", perimeter.post); // [4, 0, 0, 0]
			// DESPUÉS DE CREAR EL ARRAY [x,y,z,d,...] lanzar petición por perímetro.
			// Llamar a las coordenadas principales.
			this.__googleMapsElevationsPost(indexPerimeter, peticiones);
			//if (esCercado) this.__googleMapsElevationsPost(indexPerimeter, peticiones);
			//else this._cantidadPeticiones = 0;
		}
		this.waitElevations();
	}

	private waitElevations() {
		if (this._cantidadPeticiones === 0) {
			this._procesando = 0;
			this._status = 0;
		}
		else if (this._procesandoLimite > 20000) {
			this._procesando = 0;
			this._status = 1;
		}
		else {
			setTimeout(() => {
				this._procesandoLimite += 300;
				this.waitElevations();
			}, 300);
		}
	}

	// indexPerimetro => perímetro y datas.
	private __googleMapsElevationsPost(indexP: number, peticiones: google.maps.LatLng[]) {


		// Contador de peticiones + 1.
		this._cantidadPeticiones++;

		// Llamar a las coordenadas principales.
		let elevator = new google.maps.ElevationService();
		elevator.getElevationForLocations({ 'locations': peticiones },
			(results, status) => {
				switch (status) {
					case google.maps.ElevationStatus.OK:

						let perimeter = this._proyecto.perimetro[indexP];	// Adquirir el actual perímetro.
						// Volcado de los datos en el array.
						// console.log("perimeter.post", perimeter.post);
						for (let index = 0, post = 0; index < results.length; index++, post += CoorMaps.Offset) {

							let map = results[index]; // Datos de google.
							perimeter.post[post + CoorMaps.Lat] = map.location.lat();
							perimeter.post[post + CoorMaps.Lng] = map.location.lng();
							perimeter.post[post + CoorMaps.Elevation] = Utils.ajusteDecimal5(map.elevation);
						}

						// Recorrer todos los postes actualizados y calcular sus alturas, modificando el poste si es necesario.
						perimeter.desnivel = 0;						// Si es 1 => en el perímetro hay cambios de elevación superiores a 35º.


						let indexCoor = 0;							// Contador de coordenadas.
						let datas3d = this.datas[0];				// Contiene informacion general 3D del perímetro, indexada con indexCoor.
						//let coor = perimeter.coordenadas[0];		// Coordenadas actuales, indexada con indexCoor.

						let auxLongitud = 0;
						let previous = -CoorMaps.Offset; // Poste anterior (si existe).
						//	console.log('FOR perimeter.post.length:' + perimeter.post.length);
						for (let current = 0; current < perimeter.post.length; current += CoorMaps.Offset) {

							// El primer poste se trata aparte.
							if (current > 0) {
								// Si el poste es un angulo 8 o 16 se pasa al siguiente tramo.
								let data = perimeter.post[current + CoorMaps.Data];
								if ((data & 8) !== 0 || (data & 16) !== 0) {
									//console.log('Si el poste es un angulo 8 o 16 se pasa al siguiente tramo.');
									indexCoor++;
									datas3d = this.datas[indexCoor];
									//coor = perimeter.coordenadas[indexCoor];
								}


								// Cálculos.
								let eleCurrent = perimeter.post[current + CoorMaps.Elevation];
								let elePrevious = perimeter.post[previous + CoorMaps.Elevation];
								// console.log("________________________");
								// console.log("eleCurrent: " + eleCurrent);
								// console.log("elePrevious: " + elePrevious);
								//	let AmenorB = eleCurrent < elePrevious;

								// Cateto Y.
								let catY = Math.abs(eleCurrent - elePrevious);
								//console.log("catY: " + catY);
								// Cateto X.
								let catX = google.maps.geometry.spherical.computeDistanceBetween(
									new google.maps.LatLng(perimeter.post[current + CoorMaps.Lat], perimeter.post[current + CoorMaps.Lng]),
									new google.maps.LatLng(perimeter.post[previous + CoorMaps.Lat], perimeter.post[previous + CoorMaps.Lng])
								);
								//console.log("catY: " + catY);
								auxLongitud += catX;
								//console.log("auxLongitud: " + auxLongitud);
								// Hipotenuta.
								let hipo = Math.sqrt((catX * catX) + (catY * catY));
								//console.log("hipo: " + hipo);
								// Angulo.
								let angle = UtilsBuilder.RadianToAngle(Math.asin(catY / hipo));
								//console.log("angle: " + angle);

								// Añadir al tamaño real.
								//console.log("catY >>> " + catY);
								//console.log("angle >>> " + angle);
								if (perimeter.producto.familia.tipo === DB.VERJA) {
									//console.log("Es verja");
									let difAlturaPostes = Math.abs(eleCurrent - elePrevious)
									if (eleCurrent != elePrevious/*difAlturaPostes > 1*/) {
										//console.log("y entra en la condicion");
									//if (angle >= CoorMaps.MaxElevationDes) {
										//console.log("ES VERJA >>> Angulo mayor que el CoorMaps.MaxElevationDes");

										perimeter.post[current + CoorMaps.Data] |= 128;
										//si hay desnivel en el terreno, pasa por aquí
									}
								}
								else {

									if (angle >= CoorMaps.MaxElevationDes) {

										perimeter.post[current + CoorMaps.Data] |= 128;
									}
								}
								// console.log("MAX ELEVATION",CoorMaps.MaxElevation, "angle", angle, "maxElevationDes", CoorMaps.MaxElevationDes)

								// Contar un desnivel (35) que debe ser consultado con Rivisa.
								//console.log(`if (angle ${angle} >= CoorMaps.MaxElevation ${CoorMaps.MaxElevation}) `);
								if (angle >= CoorMaps.MaxElevation) {
									console.log('Contar un desnivel (35) que debe ser consultado con Rivisa.');
									perimeter.desnivel++;
									// Aquí se pierde, s e resuelve en el servidor.
									//perimeter.presupuesto.error = 'verja_error_inclinacion';
								}
							}
							//perimeter.longitudML += pointCurrent.distanceTo(pointPrevious);
							previous += CoorMaps.Offset;
						}

						// Obtener la longitud con elevaciones (topografíca).
						perimeter.longitudML = 0;
						for (let indexC = 0; indexC < perimeter.coordenadas.length - 1; indexC++) {
							let cA = perimeter.coordenadas[indexC].dots[0];
							let cB = perimeter.coordenadas[indexC + 1].dots[0];
							let pA = UtilsBuilder.latLngToVector3d(cA.lat, cA.lng, UtilsBuilder.EARTH + cA.ele);
							let pB = UtilsBuilder.latLngToVector3d(cB.lat, cB.lng, UtilsBuilder.EARTH + cB.ele);
							perimeter.longitudML += pA.distanceTo(pB);
						}


						//perimeter.longitud = auxLongitud;
						if (perimeter.longitudML < perimeter.longitud) {
							console.warn(`[${indexP}] perimeter.longitudML(${perimeter.longitudML}) < perimeter.longitud(${perimeter.longitud})`);
							perimeter.longitudML = perimeter.longitud;
						}
						perimeter.presupuesto.unity.ml = perimeter.longitudML;
						break;
					case google.maps.ElevationStatus.INVALID_REQUEST:
						console.error('GetorDatas3D:: Elevaciones google maps INALID REQUEST');
						break;
					case google.maps.ElevationStatus.OVER_QUERY_LIMIT:
						console.error('GetorDatas3D:: Elevaciones google maps OVER QUERY LIMIT');
						break;
					case google.maps.ElevationStatus.REQUEST_DENIED:
						console.error('GetorDatas3D:: Elevaciones google maps DENIED');
						break;
					case google.maps.ElevationStatus.UNKNOWN_ERROR:
						console.error('GetorDatas3D:: Elevaciones google maps UNKNOWN ERROR');
						break;
				}
				// Contador de peticiones - 1
				this._cantidadPeticiones--;
			});
	}

	//##################################################################################################################
	// Procesar los tramos.
	// Genera sub-secciones, por ejemplo una puerta es una sub-sección.
	// Rellena el arreglo 'subSections' con las sub-secciones, como mínimo existe 1.
	private _proccessCoordinatesSatelite(indexPerimeter: number, data: Datas3d) {
		data.coors = [];
		for (let c of data.perimetro.coordenadas) {
			let v = UtilsBuilder.latLngToVector3d(c.dots[0].lat, c.dots[0].lng);
			data.coors.push({
				x: v.x,
				y: v.y,
				z: v.z,
				sections: [],
				angleSection: 0,
				angleStart: 0,
				direction: 0,
				interm: -1,
				posteAdicional:{
					x: undefined,
					y: undefined,
					z: undefined,
				}
			});
		}

		// Calcula el angulo del tramo y los angulos de los postes extremos y sus direcciones.
		this._computeAngles2(data);

		// Obtener todos los escalones.
		//	let stairs = data.perimetro.informacion.elevaciones;
		// Almacena la altura del escalón anterior + la altura del muro ().
		let previousElevantion = data.heigthWall;


		// ###################################################### ESCALONES
		//   Un tramo es una línea que va del punto A al punto B donde A y B son las
		// coordenadas usadas para definir un perímetro en los editores.
		//   Un tramo está dividido en sub-secciones, debe existir una como mínimo.
		//   Una sub-sección es por ejemplo una puerta, una verja o cercado sin muro ...
		//
		//   subSecction {
		//	  x1, y1, // Puntos A de la sub-sección.
		//	  x2, y2, // Puntos B de la sub-sección.
		//    height // Altura en caso de que exista muro o escalones, (es la suma de ambos).
		//    magnitud // Longitud de la sub-sección.
		//    door // Es el ID de mongoDG, describe el tipo de puerta.
		//    marginA, marginB // Margenes que se crean cuando se tienen que mover los postes.
		//   }
		// ######################################################

		for (let c = 0; c < data.coors.length - 1; c++) {
			let subSection = new SubSectionSatelite(previousElevantion);
			let subSection2 = new SubSectionSatelite(previousElevantion);



			// Principal, abarca todo el tramo como una sección.
			// |-----|

			//data.coors[c].x, data.coors[c].y,	data.coors[c + 1].x, data.coors[c + 1].y,

			//  ### ESPRIVISA-77, Se generan las secciones con posteAdicional, en caso de tener posteAdicional Undefined, sigue funcionando como hasta ahora.
			if(data.coors[c+1].posteAdicional.x == undefined){

				subSection.setCoordinates(
					new THREE.Vector3(data.coors[c].x, data.coors[c].y, data.coors[c].z),
					new THREE.Vector3(data.coors[c + 1].x, data.coors[c + 1].y, data.coors[c + 1].z));
				data.coors[c].sections.push(subSection);

			}else{

					subSection.setCoordinates(
						new THREE.Vector3(data.coors[c].x, data.coors[c].y, data.coors[c].z),
						new THREE.Vector3(data.coors[c + 1].posteAdicional.x, data.coors[c + 1].posteAdicional.y , data.coors[c + 1].posteAdicional.z));

					// data.coors[c].sections.push(subSection);

					subSection2.setCoordinates(
						new THREE.Vector3(data.coors[c + 1].posteAdicional.x, data.coors[c + 1].posteAdicional.y, data.coors[c + 1].posteAdicional.z),
						new THREE.Vector3(data.coors[c + 1].x, data.coors[c + 1].y, data.coors[c + 1].z));

					data.coors[c].sections.push(subSection);
					data.coors[c].sections.push(subSection2);
			}
		}

		// ###################################################### PUERTAS
		// Evalua las puertas.
		for (let door of data.perimetro.puertas) {
			// Adquirir el tramo donde está situada.
			let tramoDoor = data.coors[door.lsp];
			if (tramoDoor.sections.length === 1) {
				if (this._oneSectionForDoor(indexPerimeter, door, tramoDoor, data.typePost)) {
					// Hacer la petición carga modelo 3D.
					if (this.WITH_3D) this.puertas.cargar3D(door.puerta.ID);
				}
			}
			else {
				//Add typePost to calculate door's length
				//Añadimos el tipo de posta para calcular la longitud de la puerta
				if (this._someSectionForDoor(indexPerimeter, door, tramoDoor, data.typePost)) {
					// Hacer la petición carga modelo 3D.
					if (this.WITH_3D) this.puertas.cargar3D(door.puerta.ID);
				}
			}
		}
	}

	// Solo hay una sección.
	private _oneSectionForDoor(indexPerimeter: number, door: ProjectDataPuerta, tramo: any, typePost: string): boolean {
		// Obtener la sección (en este caso solo hay una).
		let section = tramo.sections[0];
		// Si la sección es una puerta abortar la acción.
		if (section.door !== '') return false;

		// Longitud de la puerta.
		//const lengthDoor = this.puertas.length(door.puerta.ID);
		let lengthDoor = door.puerta.longitudTotal/1000.0;
		if (lengthDoor === 0) lengthDoor = this.puertas.length(door.puerta.ID);
		let diametroPoste = this.postes.length(typePost);

		lengthDoor = lengthDoor + (diametroPoste/2);

		// Adquirir el perímetro.
		let perimeter = this._proyecto.perimetro[indexPerimeter];
		let lengthTramo = perimeter.tramos[door.lsp + 1];	// Longitud del tramo donde está la puerta.

		// Si la longitud de la puerta es igual o mayor al tramo.
		if (lengthDoor >= lengthTramo) {
			section.height = 0;
			section.door = door.puerta.ID;
			console.log('### PUERTA 1 SECCIÓN MAYOR ' + door.puerta.ID);
			//door.margen = 0;
			return true;
		}

		// ################## DIVIDIR SECCIONES
		// Distancia de la puerta, desde el principio del tramo hasta el lugar donde está la puerta.
		let pointDoor = (lengthTramo / 100) * door.margen;
		//console.log('### MARGEN ### ' + door.margen);
		// El punto obtenido es el centro de la puerta, se debe mover al principio.
		pointDoor -= lengthDoor / 2;

		// Clonar la actual sección, será la siguiente.
		let sectionLast = section.clonarElevation();
		// Añadir la nueva sección.
		tramo.sections.push(sectionLast); // |X_|

		// ######### La puerta está al principio del tramo. |X_|
		// Solo se colocan dos secciones.
		if (pointDoor <= 0) {
			// Asignar la puerta a la primera sección.
			section.height = 0;
			section.door = door.puerta.ID;
			console.log('### PUERTA 1 SECCIÓN PRINCIPIO ' + door.puerta.ID);

			// Reordenar las secciones.
			let v = this.utilsBuilder.tramoAtoB(section.p1, section.p2,
				lengthDoor);
			section.setCoordinateP2(v); // Ajuste del punto B de la primera sección.
			sectionLast.setCoordinateP1(v); // Ajuste del punto A de la segunda sección.
			return true;
		}

		// ########## La puerta se sale. |_X|
		if ((pointDoor + lengthDoor) >= section.magnitud) {
			// Asignar la puerta a la sección finalcentral.
			sectionLast.height = 0;
			sectionLast.door = door.puerta.ID;
			console.log('### PUERTA 1 SECCIÓN SALE ' + door.puerta.ID);
			// Reordenar las secciones.
			let v = this.utilsBuilder.tramoAtoB(section.p1, section.p2, section.magnitud - lengthDoor);
			section.setCoordinateP2(v); // Ajuste del punto B de la primera sección.
			sectionLast.setCoordinateP1(v); // Ajuste del punto A de la segunda sección.
			return true;
		}

		// ########## La puerta esta en entre dos secciones. |_X_|
		let sectionLast2 = sectionLast.clonarElevation();
		//console.log("La puerta está entre dos secciones")
		tramo.sections.push(sectionLast2);

		// Asignar la puerta a la sección central.
		sectionLast.height = 0;
		sectionLast.door = door.puerta.ID;
		//console.log('### PUERTA 1 SECCIÓN ' + door.puerta.ID);

		// Reordenar las secciones.
		let v = this.utilsBuilder.tramoAtoB(section.p1, section.p2, pointDoor);
		section.setCoordinateP2(v);
		v = this.utilsBuilder.tramoAtoB(section.p1, sectionLast2.p2, pointDoor + lengthDoor);
		sectionLast.setCoordinates(section.p1, v);
		sectionLast2.setCoordinateP1(v);
		return true;
	}

	// Tiene varias secciones, hay que ver el resultado de colocar la puerta.
	//Cuando hay varias puertas dentro de un mismo lado. Ejemplo: 2 puertas en un tramo.
	private _someSectionForDoor(indexPerimeter: number, door: ProjectDataPuerta, tramo: any, typePost: string): boolean {
		// Adquirir el perímetro.
		let perimeter = this._proyecto.perimetro[indexPerimeter];
		let lengthTramo = perimeter.tramos[door.lsp + 1];	// Longitud del tramo donde está la puerta.

		// Longitud de la puerta.
		//const lengthDoor = this.puertas.length(door.puerta.ID);
		// We need to recover the real length instead of the "theorical" one,
		// otherwise the fence will start inside the door or far way from it.
		let lengthDoor = door.puerta.longitudTotal/1000.0;
		if (lengthDoor === 0) lengthDoor = this.puertas.length(door.puerta.ID);
		let diametroPoste = this.postes.length(typePost);

		lengthDoor = lengthDoor + (diametroPoste/2);


		// Distancia de la puerta, desde el principio del tramo hasta el lugar donde está la puerta.
		let pointDoor = (lengthTramo / 100) * door.margen;
		// El punto obtenido es el centro de la puerta, se debe mover al principio.
		pointDoor -= lengthDoor / 2;
		// Se sale por el punto A.
		if (pointDoor < 0) {
			pointDoor = 0;
		}

		// Buscar la sección donde se debe ubicar la puerta.
		let section: SubSectionSatelite;
		let indexSection = 0;
		let inicioSection = 0;
		for (indexSection; indexSection < tramo.sections.length; indexSection++) {
			section = tramo.sections[indexSection];
			if (pointDoor >= inicioSection && pointDoor <= (inicioSection + section.magnitud)) break;
			inicioSection += section.magnitud;
			section = undefined;
		}

		// Comprobar si se encontro la sección, en caso contrario salir del método.
		if (section === undefined) return false;

		// Si la sección es una puerta no se coloca la puerta.
		if (section.door !== '') return false;

		// Si la puerta es mayor o igual a la sección, asignarla sin dividir secciones.
		if (section.magnitud <= lengthDoor) {
			section.door = door.puerta.ID;
			section.height = 0;
			return true;
		}

		// ################## DIVIDIR SECCIONES
		// Clonar la actual sección, será la siguiente.
		let sectionLast = section.clonarElevation();
		// Añadir la nueva sección.
		tramo.sections.splice(indexSection + 1, 0, sectionLast);

		// Tener en cuenta si está muy cerca del punto A, colocar un marge de un metro.
		// En caso de estar en esta zona solo crear una nueva sección, [puerta,tramo]
		if (pointDoor < (inicioSection + 1)) { // |X_|
			// Asignar la puerta a la primera sección.
			section.height = 0;
			section.door = door.puerta.ID;

			// Reordenar las secciones.
			let v = this.utilsBuilder.tramoAtoB(section.p1, section.p2, lengthDoor);
			section.setCoordinateP2(v);
			sectionLast.setCoordinateP1(v);
			return true;
		}

		// ########## La puerta se sale. |_X|
		if ((pointDoor + lengthDoor) >= section.magnitud) {
			// Asignar la puerta a la sección finalcentral.
			sectionLast.height = 0;
			sectionLast.door = door.puerta.ID;

			// Reordenar las secciones.
			let v = this.utilsBuilder.tramoAtoB(section.p1, section.p2, section.magnitud - lengthDoor);
			section.setCoordinateP2(v);
			sectionLast.setCoordinateP1(v);
			return true;
		}

		// ########## La puerta esta en entre dos secciones. |_X_|
		let sectionLast2 = sectionLast.clonarElevation();
		tramo.sections.splice(indexSection + 2, 0, sectionLast2);

		// Asignar la puerta a la sección central.
		sectionLast.height = 0;
		sectionLast.door = door.puerta.ID;

		// Reordenar las secciones.
		let v = this.utilsBuilder.tramoAtoB(section.p1, section.p2, pointDoor);
		section.setCoordinateP2(v);
		v = this.utilsBuilder.tramoAtoB(section.p1, sectionLast2.p2, pointDoor + lengthDoor);
		sectionLast.setCoordinates(section.p2, v);
		sectionLast2.setCoordinateP1(v);
		return true;
	}

	//##################################################################################################################
	// Calcula el angulo entre dos líneas que se intersectan.
	// Obtiene la dirección del angulo.
	private _computeAngles2(data: Datas3d) {
		// Computar angulos.
		let angulos = [];
		// ############################################# CERRADO.
		//	let anterior = 0;
		for (let i = 0; i < data.coors.length - 1; i++) {
			// Inicio por defecto si está abierto y es el primero.
			let puntoAx = 0;
			let puntoAz = 0;

			// Iniciar por defecto.
			data.coors[i].interm = 0;
			data.coors[i].direction = 1;

			// Si es el primero se comporta distinto si está cerrado el perímetro.
			if (i == 0) {
				// Si está cerrado, el primer y último poste son el mismo.
				if (data.closed) { // Coger el penúltimo.
					puntoAx = data.coors[data.coors.length - 2].x; // Punto Ax
					puntoAz = data.coors[data.coors.length - 2].z; // Punto Az
				}
				else { // Es una punta.
					angulos.push({ dir: 0, grados: 0, radianes: 0 });
					continue;
				}
			}
			else { // Postes intermedios sin contar el último.
				puntoAx = data.coors[i - 1].x; // Punto Ax
				puntoAz = data.coors[i - 1].z; // Punto Az
			}



			// Obtener los calculos.
			let result = this._angles2(
				data.coors[i].x, data.coors[i].z,
				puntoAx, puntoAz,
				data.coors[i + 1].x, data.coors[i + 1].z
				);

			// Si es el primero y el perímetro está abierto, el angulo del poste base es el mismo que el del tramo.
			data.coors[i].angleStart = result.radianes;
			//data.coors[i].grados = 360 - result.grados;
			data.coors[i].grados = result.grados;
			data.coors[i].dir = result.dir;
			angulos.push(result);

			let pB = {x: data.coors[i].x, z:data.coors[i].z};
			let pA = {x: puntoAx, z: puntoAz};
			let pY = data.coors[i].y;

			let margenErrorGrados = 3;
			let resta90 = 90 - margenErrorGrados;
			let suma90 = 90 + margenErrorGrados;
			let resta180 = 180 - margenErrorGrados;
			let suma180 = 180 + margenErrorGrados;
			let resta270 = 270 - margenErrorGrados;
			let suma270 = 270 + margenErrorGrados;
			let cuadrado = -1;
			if(data.perimetro.producto.tipoPoste){
				cuadrado = data.perimetro.producto.tipoPoste.indexOf("Cuadrado");
			}

			let longitudCoors = data.coors.length-1;
			let cerrado = (data.coors[0].x == data.coors[longitudCoors].x);
			let bcond1 = cuadrado != -1;
			let bcond2 = (result.grados < resta90 || result.grados > suma90);
			let bcond3 = (result.grados < resta180 || result.grados > suma180);
			let bcond4 = (result.grados < resta270 || result.grados > suma270);
			let bcond5 = (i != 0 && !cerrado);
			let bcond6 = (i < data.coors.length-1);
			let muro = (data.perimetro.informacion.elevaciones);

			if(!cerrado){
				console.log("----CONDICIONES PARA POSTE DOBLE---");
				if(bcond1 && bcond2 && bcond3 && bcond4 && bcond5 && bcond6) {
					data.coors[i].posteAdicional = this.generaPosteDoble(pA, pB, pY);
				} else {
						console.log("----No cumple CONDICIONES PARA POSTE DOBLE---");
						data.coors[i].posteAdicional.x = undefined;
						data.coors[i].posteAdicional.y = undefined;
						data.coors[i].posteAdicional.y = undefined;
					}
			} else {
				if(bcond1 && bcond2 && bcond3 && bcond4){
					data.coors[i].posteAdicional = this.generaPosteDoble(pA, pB ,pY);
					// console.log("data coors", data.coors[i], "poste Adicional", data.coors[i].posteAdicional);
					data.coors[longitudCoors].posteAdicional.x = data.coors[0].posteAdicional.x;
					data.coors[longitudCoors].posteAdicional.y = data.coors[0].posteAdicional.y;
					data.coors[longitudCoors].posteAdicional.z = data.coors[0].posteAdicional.z;
				} else {
					data.coors[i].posteAdicional.x = undefined;
					data.coors[i].posteAdicional.y = undefined;
					data.coors[i].posteAdicional.y = undefined;
				}
			}
		}
		// Si el perímetro tiene más de dos postes se debe procesar la dirección.
		if (data.coors.length > 2) this._direccion(data, angulos);
	}

	public generaPosteDoble(pA, pB, pY){
		console.log('llamamos a la generacion de poste doble en satelite');

		// let a = {ax:result.posteBase.posteBaseX, ay:data.coors[c].y , az: pA.z} //cogemos la posicion del punto BASE
		// let b = {bx:result.postePuntoAx, by:data.coors[c + 1].y, az: pB.z} //cogemos la posicion del punto A
		//Poste cuadrado es 60x60; su fórmula es: d = raiz cuadarada de 60 al cuadrado + 60 al cuadrado = 84.85;
		let distanciaMinima = 0.084852813742385702928101323452582;// distancia de los postes cuadrados 60x06

		//necesitamos cuando el angulo es menor mayor de 90grados para añadir el poste doble

		//el vector será el resultado del poste del vector director A

		/**Para obtener la posicoin del vector director necesitamos restar la posicion del punto A y punto B de las X y de las Y */
		let vectorAx = pB.x - pA.x;
		let vectorAz = pB.z - pA.z;
		// let vectorAy = pA.y - pB.y;
		//Tenemos una propiedad de la clase y guardamos las propiedades de vector Director para poder usarlas en todo Angular
		this.vectorDirectorAB = {x: vectorAx, z: vectorAz}

		//Calculamos la normaVectorDirector
		const normaVectorDirector = Math.pow(vectorAx,2) + Math.pow(vectorAz,2);
		let ab :number;
		ab = Math.sqrt(normaVectorDirector);
		let distancia = ab - distanciaMinima;
		let porcentaje = distancia / ab;

		const posicionPosteX = pA.x + (this.vectorDirectorAB.x * porcentaje);
		const posicionPosteZ = pA.z + (this.vectorDirectorAB.z * porcentaje);

		this.posicionPosteDoble = {
			x : posicionPosteX,
			y : pY,
			z : posicionPosteZ
		}

		return this.posicionPosteDoble;
	}

	// Devuelve el tipo de poste según la dirección.
	private _direccionExtremo(datas3d: Datas3d): number { return (datas3d.direction === 1) ? 2 : 4; /* IZQ : DER */ }
	private _direccionExtremoInverso(datas3d: Datas3d): number { return (datas3d.direction === 1) ? 4 : 2; /* IZQ : DER */ }
	private _direccionAngulo(lastSection: SubSectionSatelite, coor: any, datas3d: Datas3d): number {
		let _poste = 0;
		if (lastSection && lastSection.door === '') {
			_poste = (coor.interm == 0) ? 8 : 16; // ANG : INT.
		}
		else {
			_poste = (datas3d.direction === 1) ? 2 : 4; /* IZQ : DER */
		}

		if (coor.grados) {
			if (coor.grados < 40 || coor.grados > 140) _poste |= 64; // Angulo sin tornapuntas.
		}
		return _poste;
	}

	private _direccion(data: Datas3d, angulos: any[]) {
		// Los angulos deben seguir el orden de cierre (1,1)(1,-1)(-1,-1)(-1,1) ciclico sin importar donde empieza.
		let siguiente = 0; // Ciclo lógico, guarda el siguiente angulo lógido. 0 No hay mandato. (1,2,3,4)
		let direccion = 1; // 1 Derecha, -1 izquierda; Por defecto se toma la Derecha, después se reajusta.
		let interm = 0; // Se inicia la dirección del perímetro, sentido del reloj.

		// Obtener la dirección inicial.
		let index = (data.closed) ? 0 : 1;
		if (angulos.length > 3) {
			if ((angulos[index].dir & 0x3) !== ((angulos[index + 1].dir - 1) & 0x03)) {
				interm = 1;		// Sentido del reloj.
				direccion = -1;	// Cambiar dirección.
			}
		}

		//////////////////////////////
		let angulo1 = 0; // Guarda la dirección que gana.
		for (let ang = index; ang < angulos.length; ang++) {
			// Tener en cuenta si se inicio.
			if (siguiente == 0) { 	// Iniciar ciclo.
				siguiente = angulos[ang].dir;
			}
			else { 					// Ciclo de angulos. Comprobar si rompe el ciclo.
				if (angulos[ang].dir != siguiente) { // Cambiar dirección.
					direccion *= -1;
					interm = (direccion == -1) ? 1 : 0;
					siguiente = angulos[ang].dir;
				}
			}

			// Pasar a la siguiente dirección ciclica de 1...4...1...4... en ambos sentidos.
			siguiente += direccion;
			if (siguiente > 4) siguiente = 1;
			if (siguiente < 1) siguiente = 4;

			data.coors[ang].interm = interm;
			data.coors[ang].direction = direccion;
			angulo1 += direccion;
		}

		// Dependiendo de la cantidad de angulos gana el que más tiene (ang1, ang2).
		if (angulo1 < 0) {
			data.direction = -1;
			for (let c of data.coors) {
				c.interm = (c.interm == 0) ? 1 : 0;
			}
		}
	}

	//
	private _angles2(basex: number, basez: number, //basey: number,
		x1: number, z1: number, //y1: number,
		x2: number, z2: number //y2: number,
	): any {
		// Normalizar vectores.
		x1 -= basex;
		z1 -= basez;
		x2 -= basex;
		z2 -= basez;
		// console.log(`x1:${x1} z1:${z1} x2:${x2} z2:${z2}`);
		// Obtener la orientación.
		let dir = 0;
		if ((x1 + x2) >= 0) { // (1, ?)
			dir = ((z1 + z2) >= 0) ? 1 : 2; // (1, 1) : (1, -1)
		} else { // (-1, ?)
			dir = ((z1 + z2) >= 0) ? 4 : 3; // (-1, 1) : (-1, -1)
		}

		// Producto de las líneas.
		let up = (x1 * x2) + (z1 * z2);
		let down = Math.sqrt((x1 * x1) + (z1 * z1)) * Math.sqrt((x2 * x2) + (z2 * z2));
		let r = up / down;

		let radianes = Math.acos(r);
		// if (radianes === NaN) return { dir, grados: 0, radianes: 0 };
		if (Number.isNaN(radianes)) return { dir, grados: 0, radianes: 0 };
		return { dir, grados: UtilsBuilder.RadianToAngle(radianes), radianes };
	}
}
